import { idSchema } from '@/lib/utils'
import { z } from 'zod/v4'
import type { SendDeliveryShareInput } from './delivery-shares.types'

export const deliveryShareIdSchema = z.object({
  deliveryShareId: idSchema('delivery route'),
})
export const deliveryRoutesSearchSchema = z
  .object({
    due: z.string().optional(),
    salesOrderId: idSchema('order', true),
    locationId: idSchema('location', true),
  })
  .strip()

export const deliveryShareFiltersSchema = z
  .object({
    salesOrderId: idSchema('order', true),
  })
  .strip()

export type DeliveryShareFilters = z.infer<typeof deliveryShareFiltersSchema>

const deliveryShareChannelSchema = z.enum(['email', 'sms'])
const deliveryShareDestinationSchema = z.string().trim().min(1, 'Destination is required')

/** `ShareDeliveryShareRequest`: a saved contact, or a destination when no contact is chosen. */
export const deliveryShareSendSchema = z.union([
  z.object({
    channel: deliveryShareChannelSchema,
    delivery_route_contact_id: idSchema('delivery route contact'),
    destination: deliveryShareDestinationSchema.optional(),
  }),
  z.object({
    channel: deliveryShareChannelSchema,
    destination: deliveryShareDestinationSchema,
  }),
]) satisfies z.ZodType<SendDeliveryShareInput>

export const getDeliveryShareFilters = (filters: DeliveryShareFilters): DeliveryShareFilters =>
  deliveryShareFiltersSchema.safeParse(filters).data ?? {}
